import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from "react";
import ApiService from "../services/api";

// 1. Define User type
interface User {
  id: string;
  email: string;
  role: string;
  first_name?: string;
  last_name?: string;
}

// 2. Define AuthContext type
interface AuthContextType {
  user: User | null;
  login: (user: User) => void;
  logout: () => void;
}

// 3. Create context with correct type
const AuthContext = createContext<AuthContextType | undefined>(undefined);

// 4. Provider props
interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initializeUser = async () => {
      const token = localStorage.getItem("token");
      if (token) {
        try {
          // const response = await ApiService.getUserDetails();
          // setUser(response.data);
          setUser({
            email: "syed.fahad@ibanera.com",
            first_name: "Syed",
            id: "681391a959406cc00df20034",
            last_name: "Fahad",
            role: "Admin",
          });
        } catch (error) {
          console.error("Session restore failed:", error);
          localStorage.removeItem("token");
        }
      }
      setLoading(false);
    };

    initializeUser();
  }, []);

  const login = (userData: User) => setUser(userData);
  const logout = () => {
    setUser(null);
    localStorage.removeItem("token");
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {!loading ? children : <div>Loading...</div>}
    </AuthContext.Provider>
  );
};

// 5. Hook to consume context safely
export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
